import type { ReactNode } from 'react';

import { cn } from '@/lib/utils';

interface YellowUnderlineProps {
  children: ReactNode;
  className?: string;
}

// Inline span wrapping highlighted heading text with the brand brushstroke.
// Default pb-1 override is for auth-page heading sizes (text-xl below lg);
// pages with bigger headings can suppress it via className passthrough.
export function YellowUnderline({ children, className }: YellowUnderlineProps) {
  return (
    <span className={cn('text-primary yellow-underlined max-lg:pb-1!', className)}>{children}</span>
  );
}
